<template>
  <section>
    <div v-if="loading">
      <div class="mt-4">
        <h2 class="mb-2 font-bold text-lg">Planeación</h2>

        <div class="flex justify-between">
          <planning-download-list-button
            class="mr-2"
            v-if="[1, 2, 3, 5].includes(user.team_id)"
          />
          <button
            v-if="[1, 2, 3].includes(user.team_id)"
            @click="setCreatePlanningModal(true)"
            class="button text-white bg-theme-1 shadow-md mr-2"
          >
            Crear Registro
          </button>
          <div class="flex w-1/2">
            <div class="w-2/4 flex gap-2">
              <div class="py-2 pt-2 w-20">Filtrar por:</div>
              <select
                class="input w-full border flex-1"
                @change="changeGroup($event)"
                v-model="filter.group"
                required
              >
                <option disabled selected>Seleccione la cuenta</option>
                <option
                  v-for="group in groups"
                  v-bind:key="group.id"
                  v-bind:value="group.id"
                >
                  {{ group.name }}
                </option>
                <option value="">TODAS</option>
              </select>
            </div>
          </div>
          <div class="flex gap-1">
            <button
              @click="changeWeek('minus')"
              class="button button--sm border border-theme-1 border-theme-10 text-theme-10"
            >
              <app-icon
                v-bind:name="'chevron-left'"
                v-bind:classname="'w-5'"
              ></app-icon>
            </button>
            <div class="border border-theme-1 p-2 text-theme-1 rounded-lg">
              <b>{{ start_date }}</b> al <b>{{ end_date }}</b>
            </div>
            <button
              @click="changeWeek('plus')"
              class="button button--sm border border-theme-1 border-theme-10 text-theme-10"
            >
              <app-icon
                v-bind:name="'chevron-right'"
                v-bind:classname="'w-5'"
              ></app-icon>
            </button>
          </div>
        </div>

        <HoursPlanning
          :dates="dates"
          :hours="hours"
          :hours_by_dates="hours_by_dates"
        />
        <HoursUsersPlanning
          :dates="dates"
          :users="users_team"
          :users_dates="users_dates"
        />
        <ListPlanning
          @planningCreated="planningCreated()"
          @setPlanningId="setPlanningId"
          :accounts="accounts"
          :users="users"
          :items="items"
          :user="user"
          :team_session="team_session"
        />

        <CreatePlanningModal
          v-if="createPlanningModal"
          :team_session="team_session"
          :accounts="accounts"
          :users="users"
          :planning_id="planning_id"
          @closeModal="setCreatePlanningModal(false)"
          @planningCreated="planningCreated()"
        />
      </div>
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'
import CreatePlanningModal from '@/components/admin/planning/CreatePlanningModal'
import HoursPlanning from '@/components/admin/planning/HoursPlanning'
import HoursUsersPlanning from './HoursUsersPlanning.vue'
import ListPlanning from './ListPlanning.vue'
import PlanningDownloadListButton from '@/components/admin/planning/PlanningDownloadListButton'

export default {
  name: 'AdminPlanning',
  data() {
    return {
      loading: false,
      items: [],
      accounts: [],
      users_team: [],
      users_dates: {},
      start_date: null,
      end_date: null,
      createPlanningModal: false,
      team_session: null,
      groups: [],
      filter: {
        group: null,
      },
      dates: [],
      hours: [],
      hours_by_date: [],
      firstday: null,
      users: [],
      planning_id: null,
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
  },
  async beforeMount() {
    this.team_session = localStorage.session_team
    this.session_account = localStorage.session_account
    this.getItems()
    this.getGroups()
    //this.startDay()
    this.getUsers()
  },
  methods: {
    async getItems() {
      this.loading = false
      try {
        console.log('firsday', this.firstday)
        const {
          accounts,
          list,
          start_date,
          end_date,
          filter_group,
          dates,
          hours,
          hours_by_dates,
          users,
          users_dates,
        } = await this.get(
          `/planning?team_id=${this.team_session}&account_id=${this.session_account}&group=${this.filter.group}&startdate=${this.firstday}`
        )
        this.accounts = accounts
        this.items = list
        this.dates = dates
        this.hours = hours
        this.hours_by_dates = hours_by_dates
        this.start_date = start_date
        this.end_date = end_date
        this.users_team = users
        this.users_dates = users_dates
        if (filter_group) {
          this.filter.group = filter_group
        }
        //console.log(list.length)
        this.loading = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    async getGroups() {
      this.loading = false
      try {
        const { list } = await this.get(`/account-group`)
        this.groups = list
        this.loading = true
      } catch (error) {
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    async getUsers() {
      this.loading = false
      try {
        const { list } = await this.get(`/user`)
        this.users = list
        this.loading = true
      } catch (error) {
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    async changeGroup(event) {
      this.loading = false
      this.filter.group = event.target.value
      try {
        await this.getItems()
      } catch (error) {
      } finally {
        this.loading = true
      }
    },
    startDay() {
      var curr = new Date()
      this.firstday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 1))
        .toISOString()
        .slice(0, 10)
      console.log('startDay', this.firstday)
    },
    changeWeek(val) {
      if (!this.firstday) {
        this.startDay()
      }
      var curr = new Date(this.firstday)
      if (val == 'minus') {
        this.firstday = new Date(
          curr.setDate(curr.getDate() - curr.getDay() - 7)
        )
          .toISOString()
          .slice(0, 10)
      } else {
        this.firstday = new Date(
          curr.setDate(curr.getDate() - curr.getDay() + 7)
        )
          .toISOString()
          .slice(0, 10)
      }
      this.getItems()
    },
    setCreatePlanningModal(boolean) {
      this.createPlanningModal = boolean
    },
    planningCreated() {
      console.log('planningCreated')
      this.loading = false
      this.getItems()
      this.loading = true
    },
    setPlanningId(planning_id) {
      this.planning_id = planning_id
      this.setCreatePlanningModal(true)
    },
    ...mapActions(['get']),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    CreatePlanningModal,
    HoursPlanning,
    HoursUsersPlanning,
    ListPlanning,
    PlanningDownloadListButton,
  },
}
</script>



// WEBPACK FOOTER //
// Planning.vue?984bd124